import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OrderApproval.css';
import OrderApprovalImage from '../../assets/images/OrderApproval-ic.png';

function OrderApproval() {
    const navigate = useNavigate();

    return (
        <div className="approval-submitted-page">
            <div className="modal-overlay">
                <div className="approval-modal-wrapper">
                    <button 
                        className="modal-close-btn"
                        onClick={() => navigate('/')}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                    
                    <div className="approval-modal">
                        <div className="title-with-icon">
                            <div className="success-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" fill="#4ade80" />
                                    <path 
                                        d="M9 12l2 2 4-4" 
                                        stroke="#fff" 
                                        strokeWidth="2.5" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <h2 className="modal-title">Order Approval Submitted!</h2>
                        </div>

                        <p className="modal-message">
                            Please wait for an email confirmation from our team before proceeding to checkout. 
                            In the meantime, feel free to continue shopping or view your submitted orders in 
                            the Pending Approval section in Purchase History.
                        </p>

                        <div className="celebration-illustration">
                            <img src={OrderApprovalImage} alt="Order Approval" />
                        </div>

                        <div className="modal-actions">
                            <button 
                                className="continue-shopping-modal-btn"
                                onClick={() => navigate('/')}
                            >
                                Continue Shopping
                            </button>
                            <button 
                                className="purchase-history-btn"
                                onClick={() => navigate('/account/purchase-history')}
                            >
                                Purchase History
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderApproval;